import { Row, Col, Card } from "antd";
import { useDispatch } from "react-redux";
import { getApis } from "components/Common/apis";
import { useCallback, useEffect, useState } from "react";
import { vehicleHeartBeatStatisticsApiUrl } from "components/Common/endpoints";
import ConnectivityStatisticsTable from "./Table";
import BarChartHBStatistics from "./BarChart";
import { setPageLoader } from "reducers/loaderSlice";

const Connectivity = () => {
  const dispatch = useDispatch();
  const [HBTestPassData, setDynoTestPassData] = useState({
    List: [],
    modeList: [],
    modelList: [],
  });
  const authToken = localStorage.getItem("authToken");

  const getHeartBeatStatisticDetails = useCallback(
    async () => {
      await getApis(vehicleHeartBeatStatisticsApiUrl, {}, authToken)
        .then((res) => {
          setDynoTestPassData({
            Graph: res?.data?.overall || {},
            List: res?.data?.modelWiseData || [],
          });
        })
        .catch((e) => console.log(e));
      dispatch(setPageLoader(null));
    },
    // eslint-disable-next-line
    [authToken]
  );

  useEffect(() => {
    dispatch(setPageLoader("refresh"));
    getHeartBeatStatisticDetails();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getHeartBeatStatisticDetails]);

  return (
    <Row
      gutter={{
        xs: 8,
        sm: 16,
        md: 24,
      }}
    >
      <Col xs={24} sm={24} md={12} lg={12} xl={12} id="heartbeat-history-one">
        <Card title="Connectivity Tests - All Models" className="h100">
          <BarChartHBStatistics HBTestPassData={HBTestPassData?.Graph} />
        </Card>
      </Col>
      <Col xs={24} sm={24} md={12} lg={12} xl={12} id="heartbeat-history-one">
        <Card title="Connectivity Tests - Model wise" className="h100">
          <ConnectivityStatisticsTable tableData={HBTestPassData?.List} />
        </Card>
      </Col>
    </Row>
  );
};

export default Connectivity;
